<template>
  <el-dialog title="基本信息" :visible.sync="dialogFormVisible" custom-class="medium-dialog" center
             :close-on-click-modal="false" :append-to-body="true">
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="18">
        <el-form-item label="参数：" :label-width="formLabelWidth" prop="fiscalsysguid" style="width: 70%">
          <el-input v-model="form.fiscalsysguid" auto-complete="off" :required="true" disabled></el-input>
        </el-form-item>
      </el-row>
      <el-row :gutter="18">
        <el-form-item label="描述：" :label-width="formLabelWidth" prop="paraname">
          <el-input v-model="form.paraname" auto-complete="off" :required="true"></el-input>
        </el-form-item>
      </el-row>
      <el-row :gutter="18">
        <el-form-item label="内容：" :label-width="formLabelWidth" prop="paracontent">
          <el-input
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 10}"
            placeholder="请输入内容"
            v-model="form.paracontent">
          </el-input>
        </el-form-item>
      </el-row>
      <el-row :gutter="18">
        <el-form-item label="上传图片：" :label-width="formLabelWidth" v-if="form.fiscalsysguid=='logimg'||form.fiscalsysguid=='loginimg'||form.fiscalsysguid=='zfbimg'||form.fiscalsysguid=='wximg'">
          <CommonUpload ref="refguanggao" :allowOpen="true" :showList="false"
                        :fixedFileName="fixedFileName" @emitNewFile="emitNewFile" :groupGuid="groupGuid" groupType="paramer"  :accept="'.png,.jpg,.jpeg'"></CommonUpload>
          <img :src="(form.fiscalsysguid=='logimg'||form.fiscalsysguid=='loginimg'||form.fiscalsysguid=='zfbimg'||form.fiscalsysguid=='wximg')?form.paracontent:''" style="background-color: #bbbbbb"></img>
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer"><span style="color:green"></span>
      <el-button @click="dialogFormVisible = false">关 闭</el-button>
      <el-button type="primary" @click="updateData" :loading="CanEdit">修 改</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {sysupdateparacontent} from '@/api/sysmanage/sysmanage';

  export default {
    name: "ParameterMaintainEdit",
    data() {
      return {
        dialogFormVisible: false,
        CanEdit: false,//防止多次提交
        groupGuid:'',
        form: {  //表单数据
          fiscalsysguid: '',//制度类型
          paragroup: '',//参数分类
          paraname: '',//参数名称
          paracontent: '',//配置内容
          tenantid: ''//
        },
        fixedFileName:'',
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          paraname: [
            {required: true, message: '请输入参数', trigger: 'blur'},
          ]
        },
      }
    },
    methods: {
      show() {
        this.dialogFormVisible = true
        this.initForm()
      },
      updateData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.CanEdit = true
            sysupdateparacontent(this.form).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.dialogFormVisible = false
                //刷新列表
                this.$emit('bindGuid');

              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
                this.CanEdit = false
              }
            });
          }
        })
      },
      initData(row) {
        for (let i in this.form) {
          this.form[i] = row[i]
        }
        this.groupGuid=this.form.paragroup+this.form.fiscalsysguid+this.form.tenantid
        this.fixedFileName='f.png';
      },
      initForm() {
        for (let i in this.form) {
          this.form[i] = ""
        }
        this.CanEdit = false
        if (this.$refs.refguanggao) {
          this.$refs.refguanggao.reset();
        }
      },
      emitNewFile(file){
        if(file)
          this.form.paracontent=file.url;
      }
    },
    mounted() {
    },
    components: {}
  }
</script>


<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .query-table td.content {
    text-align: center;
  }

  .query-table td.mainlink {
    font-weight: bold;
  }

  .titlecolor {
    color: #20A0FF;
    width: 100%;
  }

  .serverAlertCss {
    line-height: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sysmanage/parametermaintain/ParameterMaintainEdit.vue